<script>
import FacilityLinksDetails from "@/modules/facilities/components/FacilityLinksDetails.vue";
import FacilityLinksDocuments from "@/modules/facilities/components/FacilityLinksDocuments.vue";
import FacilityProjectLinks from "@/modules/projects/components/FacilityProjectLinks.vue";
import LandEntityLinksDetails from "@/modules/landEntities/components/LandEntityLinksDetails.vue";
import FacilityComplexLinksDetails from "@/modules/facilities/components/FacilityComplexLinksDetails.vue";
import ConstructionStandardLinks from "@/modules/constructionStandards/components/ConstructionStandardLinks.vue";

export default {
  name: "GlobalSearchResult",
  components: {
    ConstructionStandardLinks,
    FacilityComplexLinksDetails,
    LandEntityLinksDetails, FacilityProjectLinks, FacilityLinksDocuments, FacilityLinksDetails
  },

  props: {
    result: null
  },

  computed: {
    title() {
      return this.result.Description || ''
    }
  }
}
</script>

<template>
  <v-card class="pa-2" v-if="result !== null">
    <facility-links-details v-if="result.__typename === 'Facility'"
                            :facility-id="result.facilityId"></facility-links-details>

    <facility-complex-links-details v-if="result.__typename === 'FacilityComplex'"
                                    :complex-id="result.complexId"></facility-complex-links-details>

    <facility-links-documents v-if="result.__typename === 'Facility' || result.__typename === 'FacilityComplex'"
                              :facility-id="result.facilityId"></facility-links-documents>


    <facility-project-links v-if="result.__typename === 'FacilityProject'"
                            :project="result"></facility-project-links>

    <land-entity-links-details v-if="result.__typename === 'LandEntity'"
                               :facility-id="result.facilityId"></land-entity-links-details>

    <construction-standard-links
        v-if="result.__typename === 'DesignGuideline' || result.__typename === 'FrontEndDocument' || result.__typename === 'TechnicalStandard' || result.__typename === 'StandardDetail'"
        :construction-standard="result"></construction-standard-links>
  </v-card>
</template>

<style scoped>

</style>
